
export const defaultLocale = 'zhCN';
export const localeOptions=[
    { id:'en',name:'English', langid:1252, lang:'eng' },
    { id:'zhCN',name:'简体中文', langid:936, lang:'simp' },
    { id:'zhHK',name:'繁體中文', langid:950, lang:'trad' },
];
export const showcode = 'CPS22DB';
export const showid = 9991;
// export const webresources_prefix = "lbl_EMPBE";
export const webresources_prefix = "lbl";
export const itemcode = "P1BE";
export const projectcode = showcode + "_P1BE";
export const paymentInfoGuid = "9a6e88801141435592e05d1e99d1b879";
export const isShowAdOverview = false;
export const IsUAT = process.env.VUE_APP_EMP_IsUat === 'true' || process.env.VUE_APP_EMP_IsUat === '1';

/** 操作日誌列表/導出：單次 HTTP 請求超時（毫秒）。與需求「後端處理超過 10 分鐘判定逾時」對齊；多頁導出時每頁獨立計時。 */
export const logExportRequestTimeoutMs = 10 * 60 * 1000;
